(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-list"] && !Shopify.designMode) return;
  try {
    
function moveCollectionLabelToMidBottom() {
  var section = document.querySelector('[data-collection-label-bottom]');
  if (!section) return;
  var titles = section.querySelectorAll('h3, [class*="title"]');
  function setMidBottom(el) {
    if (!el || el.nodeType !== 1) return;
    el.style.setProperty('position', 'absolute', 'important');
    el.style.setProperty('top', 'auto', 'important');
    el.style.setProperty('left', '0', 'important');
    el.style.setProperty('right', '0', 'important');
    el.style.setProperty('bottom', '0', 'important');
    el.style.setProperty('width', '100%', 'important');
    el.style.setProperty('margin', '0', 'important');
    el.style.setProperty('transform', 'none', 'important');
    el.style.setProperty('display', 'flex', 'important');
    el.style.setProperty('flex-direction', 'row', 'important');
    el.style.setProperty('align-items', 'flex-end', 'important');
    el.style.setProperty('justify-content', 'center', 'important');
    el.style.setProperty('padding', '14px 16px', 'important');
    el.style.setProperty('text-align', 'center', 'important');
    el.style.setProperty('box-sizing', 'border-box', 'important');
  }
  function setTitleCenter(titleEl) {
    if (!titleEl || titleEl.nodeType !== 1) return;
    titleEl.style.setProperty('margin', '0 auto', 'important');
    titleEl.style.setProperty('text-align', 'center', 'important');
    titleEl.style.setProperty('width', '100%', 'important');
    var fs = window.getComputedStyle(titleEl).fontSize;
    var num = parseFloat(fs) || 16;
    titleEl.style.setProperty('font-size', (num + 5) + 'px', 'important');
  }
  function setRelative(el) {
    if (el && el.nodeType === 1) el.style.setProperty('position', 'relative', 'important');
  }
  titles.forEach(function(title) {
    var wrapper = title.parentElement;
    if (!wrapper) return;
    setMidBottom(wrapper);
    setTitleCenter(title);
    var container = wrapper.parentElement;
    setRelative(container);
    if (container && container.tagName === 'A') setRelative(container.parentElement);
  });
  var items = section.querySelectorAll('.t4s-col-item, .t4s-collection-item');
  items.forEach(function(item) {
    var w = item.querySelector('.t4s-cat_grid_item__wrapper') || item.querySelector('[class*="cat_grid_item__wrapper"]');
    if (w) {
      setMidBottom(w);
      var title = w.querySelector('h3, [class*="title"]');
      if (title) setTitleCenter(title);
      var content = item.querySelector('.t4s-cat_grid_item__content');
      if (content) setRelative(content);
      if (w.parentElement) setRelative(w.parentElement);
    }
  });
}
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', moveCollectionLabelToMidBottom);
} else {
  moveCollectionLabelToMidBottom();
}
setTimeout(moveCollectionLabelToMidBottom, 500);

  } catch(e) { console.error(e); }
})();
})();
